import { loadScript } from '../load-strategies/RecaptchaSdkLoader';

export default {
  name: 'recaptcha',
  loader: loadScript,
};
